import { Modal } from '@bfe/moly';
import { invoke, isMobile } from '@web3/utils';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Case, Switch } from 'react-if';
import { getDefaultIndex } from '../../store/config';
import { useLocale } from '../../store/i18nMessage';
import { usePermission } from '../../store/permission';
import { useCurrentWallet } from '../../store/userWallet';
import { TokenItemWithChain, WalletTypesNumber } from '../../types';
import { DisplayToken, DisplayTokenDeposit } from './DisplayTokenDeposit';
import { TokenPanel } from './TokenPanel';
import './style.scss';

export type Web3DepositModalProps = {
  visible: boolean;
  onClose?: () => void;
  onSelectToken?: (token?: TokenItemWithChain) => void;
  token?: DisplayToken;
  // 选token的界面，初始chainCode
  initialChainCode?: string;
  zIndex?: number;
};

export function Web3DepositModal({ visible, onClose, initialChainCode, onSelectToken, token, zIndex = getDefaultIndex() }: Web3DepositModalProps) {
  const { isLawRestricted } = usePermission();
  const { getAddress, walletType, btcAddressType } = useCurrentWallet();
  const { t } = useLocale();
  const [stateToken, setStateToken] = useState<DisplayToken>();
  const displayToken = token || stateToken;

  useEffect(() => {
    if (visible && !token) {
      // 如果外面没传token，在visible时将状态重置
      setStateToken(undefined);
    }
  }, [visible, token]);

  if (isLawRestricted) {
    return null;
  }

  const selectToken = (token?: TokenItemWithChain) => {
    if (onSelectToken) {
      onSelectToken(token);
    }
    setStateToken(
      token
        ? {
            chainCode: token.chainCode,
            token: token.symbol,
          }
        : undefined,
    );
  };

  const hideReturn = !displayToken || Boolean(token && !onSelectToken);

  const modalTitle = invoke(() => {
    if (!displayToken) {
      return t('select_token');
    }
    const title = `${t('received')} ${displayToken.token}`;
    return title;
  });

  return (
    <Modal
      open={visible}
      modal={false}
      onCancel={onClose}
      footer={null}
      title={modalTitle}
      isMobile={isMobile}
      direction={!isMobile ? 'center' : 'bottom'}
      arrowEnable={!hideReturn}
      arrowHandler={() => selectToken()}
      className={clsx('web3-deposit-modal')}
      width={480}
      zIndex={zIndex}
      contextWrapper={clsx('wdm-content-body', Boolean(displayToken) && 'better-scroll overflow-auto')}
    >
      <Switch>
        <Case condition={!displayToken}>
          <TokenPanel initialChainCode={initialChainCode} onSelectToken={selectToken} />
        </Case>
        <Case condition={Boolean(displayToken)}>
          <DisplayTokenDeposit
            chainCode={displayToken?.chainCode}
            walletAddress={displayToken?.walletAddress || getAddress(displayToken?.chainCode)}
            addressType={displayToken?.chainCode === 'BTC' ? btcAddressType : ''}
            mneChain={walletType !== WalletTypesNumber.CLOUD}
            token={displayToken?.token}
          />
        </Case>
      </Switch>
    </Modal>
  );
}
